import { MaterialDetailsComponent } from './eyedes/handbook/material-details/material-details.component'
import { ComponentTypeComponent } from './eyedes/handbook/component-type/component-type.component'
import { CatalogueObjectTypeComponent } from './eyedes/handbook/catalogue-object-type/catalogue-object-type.component'
import { SuppliersComponent } from './eyedes/handbook/suppliers/suppliers.component'
import { RegionOfSourcingComponent } from './eyedes/handbook/region-of-sourcing/region-of-sourcing.component'
import { BaseMaterialComponent } from './eyedes/handbook/base-material/base-material.component'
import { HandbookTypesResolver, SupplierLibraryComponent } from '@surgetech-eu/core'

export const Libraries = {
    eyedes: {
        resolver: HandbookTypesResolver,
        pages: [
            {
                name: 'item-material-and-certification',
                title: 'Item Material and Certification',
                component: MaterialDetailsComponent
            },
            {
                name: 'component-type',
                title: 'Component Type',
                component: ComponentTypeComponent
            },
            {
                name: 'catalogue-object-type',
                title: 'Catalogue Object Type',
                component: CatalogueObjectTypeComponent
            },
            {
                name: 'damTagsLibrary',
                title: 'Tags Library Product Images',
                isKeyReadOnly: true
            },
            {
                name: 'contentTagsLibrary',
                title: 'Tags Library Contents',
                isKeyReadOnly: true
            },
            {
                name: 'supplier',
                title: 'Suppliers',
                component: SuppliersComponent
            },
            {
                name: 'regionOfSourcing',
                title: 'Region of Sourcing',
                component: RegionOfSourcingComponent
            },
            {
                name: 'baseMaterial',
                title: 'Base/Plating Material KEYE',
                component: BaseMaterialComponent
            }
        ]
    },
    eyeman: {
        resolver: HandbookTypesResolver,
        pages: [
            {
                name: 'supplier',
                title: 'Supplier',
                component: SupplierLibraryComponent
            }
        ]
    },
    cmpman: {
        resolver: HandbookTypesResolver,
        pages: [
            {
                name: 'supplier',
                title: 'Supplier',
                component: SupplierLibraryComponent
            }
        ]
    },
    galvman: {
        resolver: HandbookTypesResolver,
        pages: [
            {
                name: 'supplier',
                title: 'Supplier',
                component: SupplierLibraryComponent
            }
        ]
    }
}
